import step1 from "../../assets/images/onboarding/step-1.png";
import step2 from "../../assets/images/onboarding/step-2.png";
import step3 from "../../assets/images/onboarding/step-3.png";
import step4 from "../../assets/images/onboarding/step-4.png";
import step5 from "../../assets/images/onboarding/step-5.png";
import {useLocation} from "react-router-dom";
import {useEffect, useState} from "react";
import {BaSeButton} from "@base/react";
import "./index.scss";
import ApiGeneral from "../../services/general";
import {getCurrentCNPJ} from "../../services/utils";
import {useApp} from "../../hooks/use-app";

const Onboarding = ({ setHideOnboarding, callBack, typePage = false }) => {
  const {companies} = useApp()
  const location = useLocation();
  const howToUsePage = location.pathname === "/como-utilizar";
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkIsMobile = () => setIsMobile(window.innerWidth <= 768);
    checkIsMobile();
    window.addEventListener("resize", checkIsMobile);
    return () => window.removeEventListener("resize", checkIsMobile);
  }, []);

  const [currentStep, setCurrentStep] = useState(1);
  const contentSteps = [
    {
      img: step1,
      textsDesktop: [
        {
          title: "Bem-vindo(a)!",
          subtitle: `Aqui você organiza o planejamento financeiro da sua empresa de forma rápida e prática. <br /><br/> Veja o que você pode fazer:`,
        },
      ],
      textsMobile: [
        {
          title: "Bem-vindo(a)!",
          subtitle: `Aqui você organiza o planejamento financeiro da sua empresa de forma rápida e prática. Veja o que você pode fazer:`,
        },
      ],
    },
    {
      img: step2,
      texts: [
        {
          title: "Projete seu Fluxo de Caixa",
          subtitle: `Informe saldo em caixa, investimentos, financiamentos e dívidas para prever o comportamento financeiro.`,
        },
      ],
    },
    {
      img: step3,
      texts: [
        {
          title: "Analise seus Resultados",
          subtitle: `Visualize automaticamente indicadores como rentabilidade e lucratividade para tomar decisões estratégicas.`,
        },
      ],
    },
    {
      img: step4,
      texts: [
        {
          title: "Prepare-se para Buscar Crédito",
          subtitle:
            "Avalie a necessidade de garantias reais e se organize para solicitar crédito com mais segurança.",
        },
      ],
    },
    {
      img: step5,
      texts: [
        {
          title: "Vamos começar?",
          subtitle: `Antes de seguir, selecione a empresa para a qual deseja fazer o planejamento ou escolha a opção de realizar com o seu CPF.<br/><br/>
                 Depois, aproveite a navegação guiada para conhecer todos os recursos do app!<br/><br/>
                 Para maiores informações acesse nosso <a href="/manuais-planejadora-2026-2.pdf" target="_blank" rel="noopener noreferrer">Manual Técnico</a>.`,
        },
      ],
    },
  ];

  const FakeDots = () => {
    return (
      <div className="onboarding__dots">
        <ul>
          {contentSteps.map((item, k) => (
            <li
              key={k}
              className={currentStep === k + 1 ? "active" : ""}
              onClick={() => setCurrentStep(k + 1)}
            ></li>
          ))}
        </ul>
      </div>
    );
  };
  const navigateTemplate = () => {
    return (
      <>
        {currentStep >= 1 && currentStep < 5 ? (
          <div className="guide-buttons-area">
            <span
              className="close-guide"
              onClick={() => {
                setHideOnboarding(true);
                ApiGeneral().sendDigitalMoments('access_manual', {
                  cnpj: getCurrentCNPJ(companies) || null
                })
                if (callBack) callBack();
              }}
            >
              Fechar
            </span>
            <BaSeButton
              buttonType="button"
              color="#2E5DE6"
              onClick={() => {
                setCurrentStep(currentStep + 1);
              }}
              size="medium"
              value="Próximo"
              width="100%"
            />
          </div>
        ) : (
          <BaSeButton
            buttonType="button"
            color="#2E5DE6"
            onClick={() => {
              setHideOnboarding(true);
              ApiGeneral().sendDigitalMoments('access_manual', {
                cnpj: getCurrentCNPJ(companies) || null
              })
              if (callBack) callBack();
            }}
            size="medium"
            value="Vamos lá!"
            width="100%"
          />
        )}
      </>
    );
  };

  useEffect(() => {
    if (!typePage) {
      setTimeout(() => {
        document.body.style.overflow = "hidden";
      }, 300);
    } else {
      setTimeout(() => {
        document.body.style.overflow = "";
      }, 300);
    }
  }, [typePage]);

  return (
    <div
      className={`onboarding ${typePage ? "type-page" : ""} ${
        howToUsePage ? "on-onboarding" : ""
      }`}
    >
      <div className="content">
        <div className={"container minimal-scrollbar wrapper "+(currentStep === 5 ? 'last-step' : '')}>
          <div className="steps">
            {contentSteps.map((item, i) => {
              let count = i + 1;

              const textsToRender =
                i === 0
                  ? isMobile
                    ? item.textsMobile
                    : item.textsDesktop
                  : item.texts;

              return count === currentStep ? (
                <div key={count} className="step">
                  <figure>
                    <img src={item.img} alt={`step-${count}`} loading="lazy" />
                  </figure>
                  <div className="text">
                    {/*<p className="pages-desktop">*/}
                    {/*  {currentStep}/{contentSteps.length}*/}
                    {/*</p>*/}
                    {textsToRender.map((textItem, key) => (
                      <div className="wrapper-texts" key={key}>
                        {textItem.title ? (
                          textItem.title ===
                          "Preencha seus Dados Financeiros" ? (
                            <h2
                              style={{ margin: 0 }}
                              dangerouslySetInnerHTML={{
                                __html: textItem.title,
                              }}
                            />
                          ) : (
                            <h2
                              dangerouslySetInnerHTML={{
                                __html: textItem.title,
                              }}
                            />
                          )
                        ) : null}

                        {textItem.subtitle ? (
                          <p
                            dangerouslySetInnerHTML={{
                              __html: textItem.subtitle,
                            }}
                          />
                        ) : null}
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                ""
              );
            })}
          </div>
          <FakeDots />
        </div>
        <div className="onboarding__footer">
          <div className="container">{navigateTemplate()}</div>
        </div>
      </div>
    </div>
  );
};

export default Onboarding;
